(function () {
    'use strict';

    angular
        .module('app')
        .directive('drvTfnInput', drvTfnInput);
        
    drvTfnInput.$inject = [];

        /**
         * @ngdoc directive
         * @name drvTfnInput
         * @description Tfn input which includes validation.
         *
         * @param {string} value - Tfn
         * @param {object} field - An entity field object
         */
        function drvTfnInput() {
            drvTfnInputCtrl.$inject = [];

            return  {
                templateUrl: 'app/fieldinput/tfn-input.tmpl.html',
                require: "ngModel",
                scope: {
                },
                controller: drvTfnInputCtrl,
                controllerAs: 'drvCtrl',
                bindToController: {
                    value: '=ngModel',
                    field: '='
                },
                link: link
            };

            function drvTfnInputCtrl() {
                /* jshint validthis:true */
                var drvCtrl = this;
                drvCtrl.validateTfn = validateTfn;

                /*
                 * Check to see if the Tfn is valid
                 */
                function validateTfn(tfn) {
                    // TFN numbers which don't match the validation algorithm but are considered valid
                    var specialTfn =
                    [
                        "333333333", /* Investor under 16 */
                        "444444441", /* Pensioner */
                        "444444442", /* Other Social Security*/
                        "555555555",  /* Not required to lodge an income tax return */
                        "666666666", /* Investors in the business of providing consumer or business finance */
                        "777777777", /* Norfolk Island residents */
                        "888888888", /* Non_residents */
                        "987654321" /* Alphabetic ch. qouted in TFN */
                    ];

                    var eightDigitWeightings = [ 10, 7, 8, 4, 6, 3, 5, 1 ];
                    var nineDigitWeights = [ 10, 7, 8, 4, 6, 3, 5, 2, 1 ];

                    var valid = false;

                    if (!_.isNil(tfn) && tfn !== '') {
                        if (_.contains(specialTfn, tfn)) {
                            valid = true;
                        } else if ((tfn.length === 8 || tfn.length === 9) && !isNaN(tfn)) {
                            var productsSum = 0;
                            var weightings = [];

                            if (tfn.length === 8) {
                                weightings = eightDigitWeightings;
                            } else {
                                weightings = nineDigitWeights;
                            }

                            for (var i = 0; i < weightings.length; i++) {
                                productsSum += parseInt(tfn[i]) * weightings[i];
                            }

                            valid = productsSum % 11 === 0;
                        }
                    } else {
                        valid = true;
                    }

                    return valid;
                }
            }
        }

        /*
         * Link function which will handle validation
         */
        function link($scope, $element, $attrs, $ctrl) {
            $scope.pni[$scope.drvCtrl.field.Name].$validators.formatValid = function required(modelValue, viewValue) {
                return $scope.drvCtrl.validateTfn(modelValue);
            };
        }
})();